module.exports = __webpack_public_path__ + "static/media/quieromibarrio4.521e90f3.webp";